import React, { MouseEvent, KeyboardEvent } from "react";
import cn from "classnames";
import { IconButton } from "@src/components/atoms/buttons/icon-button/icon-button";
import styles from "./check-box-with-text.module.scss";
import checkBoxIcon from "@src/assets/svg/checkbox-icon.svg";
import checkBoxCheckedIcon from "@src/assets/svg/checked-checkbox-icon.svg";

interface CheckBoxWithTextPropTypes {
  text: string;
  variant?: string | string[];
  checkboxState: boolean;
  handleCheckBoxClick: (
    e: MouseEvent | KeyboardEvent,
    checkboxState: boolean,
  ) => void;
}

const cssClassName = "check-box-with-text";

export const CheckBoxWithText = ({
  text,
  variant,
  checkboxState,
  handleCheckBoxClick,
  ...rest
}: CheckBoxWithTextPropTypes) => {
  const returnCheckboxIconByState = (childInfo: boolean) => {
    return childInfo ? checkBoxCheckedIcon : checkBoxIcon;
  };

  let variantClass = "";

  if (typeof variant === "string") {
    variantClass = styles[`${cssClassName}__label--${variant}`];
  } else if (Array.isArray(variant)) {
    variantClass = variant
      .map((v) => styles[`${cssClassName}__label--${v}`])
      .join(" ");
  }

  const handleClick = (e: MouseEvent | KeyboardEvent) => {
    e.preventDefault();
    handleCheckBoxClick(e, !checkboxState);
  };

  return (
    <div className={styles[cssClassName]} {...rest}>
      <IconButton
        icon={returnCheckboxIconByState(checkboxState)}
        fun={handleClick}
      />
      <span className={cn(styles[`${cssClassName}__label`], variantClass)}>
        {text}
      </span>
    </div>
  );
};
